<template>
  <div class="goals-widget">
    <div class="header-row">
      <span class="icon-wrapper">
        <icon name="star-circle" />
      </span>
      <span>Daily Goal</span>
      <span class="spacer"></span>
      <span>
        <button
          class="clear-button"
          @click="handleClick"
        >
          <icon name="dots" variant="9AA4B2" class="dots-icon" />
        </button>
      </span>
    </div>
    <div>
      <div class="hero">
        {{ todaysCount }}/{{ studyGoal }}
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'GoalWidget',
  components: {
    Icon,
  },
  props: {
    flashcardStats: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      goalsDefault: [
        {
          'goal': 10,
          'timeEstimate':'(Approximately 10-15 minutes.)',
        },
        {
          'goal': 20,
          'timeEstimate':'(Approximately 20-30 minutes.)',
        },
        {
          'goal': 30,
          'timeEstimate':'(Approximately 1 hour.)',
        },
      ],
    };
  },
  computed: {
    studyGoal() {
      return this.$store.getters['session/currentUser'].userProfile?.studyGoal || 10;
    },
    todaysCount() {
      const today = new Date().toISOString().split('T')[0];
      const todaysStats = this.flashcardStats.filter((stat) => stat.date === today);
      if (todaysStats?.length > 0) {
      return todaysStats[0].count;
    }
      return 0;
    },
  },
  methods: {
    handleClick() {
      this.$modal.show('study-goal-set', { goals: this.goalsDefault });
    },
  },
};
</script>

<style scoped lang="scss">
.dots-icon {
  height: 14px;
}

.clear-button {
  background-color: transparent;
  padding: 0;
  margin: 0;
}

.icon-wrapper {
  transform: translateY(3px);
}
@include breakpoint(small) {
  .header-row {
    margin-bottom: rem-calc(8);
    gap: rem-calc(4);
    font-size: rem-calc(14);
    line-height: rem-calc(16);
  }
  .hero {
    font-size: rem-calc(20);
    line-height: rem-calc(24);
    font-weight: 600;
  }
}
</style>
